import React from 'react';
import styled from 'styled-components/macro';
import Header from '../containers/Header';
import { useTranslate } from '../contexts/languageContext';
import { usePage } from '../contexts/pageContext';
import { getColorOfElec } from '../commons/js/util.js';
import HeaderTitle from '../components/Headers/HeaderTitle/index'
import FooterLayout from '../components/Footer/Footer';
import { responsive } from '../resources/constantes.json';
import LowerBanner from './LowerBanner';
import { useIsDesktopReal } from '../hooks/useMediaQuery';
import DatosDeEnvio from './DatosDeEnvio';
import Logo from '../assets/img/COBRANDING_ELECCIONES_2023-08.png';
import { getParents } from '../utils';

const LayoutResultados = ({ children, nomenclator }) => {
  const t = useTranslate();
  const isDesktop = useIsDesktopReal();
  const pageState = usePage();
  const { data, urlInfo } = pageState;
  const { id, eleccion, page, idHistorico } = urlInfo;
  const esHistorico = idHistorico != null;
  const ambito = nomenclator.ambitos[eleccion][id];
  const nombreEleccion = nomenclator.nomAmbitos[eleccion].n;
  const primerColor = esHistorico ? '#d2d2d2' : '#fff';
  const segundoColor = esHistorico ? '#EDEDED' : '#222';
  const colorElec = getColorOfElec(page, nomenclator);
  const esBoletin = data.tope === '1';


  const genealogy = [ambito.i, ...getParents(ambito.i, eleccion, nomenclator, ambito.l)];
  const genealogyNames = isDesktop ? genealogy
    .map((item) => { return nomenclator.ambitos[eleccion][item].n.toLowerCase() })
    .slice(0, 2)
    .reverse().join(' / ')
    : ambito.n

  //const title = getTitle(id, eleccion, nomenclator, page, t, idHistorico);
  return (
    <Layout primerColor={primerColor} segundoColor={segundoColor}>
      <ResultadosContent>
        <Header
          variant={'resultados'}
          esHistorico={esHistorico}
          nomenclator={nomenclator}
          ambito={ambito}
          data={data}
          {...urlInfo}
        >
          {!esHistorico ? (
            <>
              {isDesktop
                ?
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <ContenedorLogos>
                    <img src={Logo} alt={'Logos'} style={{ padding: '0px', height: "100%" }} />
                  </ContenedorLogos>
                  <LowerBanner
                    nomenclator={nomenclator}
                    ambito={ambito}
                    eleccion={eleccion}
                    page={page}
                    variant={'resultados'}
                    esHistorico={esHistorico}
                    data={data}
                  />
                </div>
                :
                <HeaderTitle title={nombreEleccion} subtitle={ambito.n} color={colorElec} marginBottom={'unset'} />
              }
            </>
          ) : (
            <HeaderHistorico>
              <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                  {isDesktop &&
                    <ContenedorLogos>
                      <img src={Logo} alt={'Logos'} style={{ padding: '0px', height: "100%" }} />
                    </ContenedorLogos>
                  }
                  <div style={{ display: "flex", gap: "2rem", alignItems: 'center' }}>
                    <HeaderTitle title={genealogyNames} color={colorElec} marginBottom={'unset'} withColorBar={!isDesktop} withDropdown={false} />
                    <HistoricContainer style={{ color: '#164192' }}>
                      (
                      {data.tope === '1' ? t('boletinAnterior') : t('avanceAnterior')}
                      )
                    </HistoricContainer>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "row" }}>
                <DatosDeEnvio datoFecha={data.mdhm} />
                <span
                  css="
                      font-weight: bold;
                      text-transform: uppercase;
                      padding: 10px;
                      box-sizing: border-box;
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      color: #fff;
                      max-width: 200px;
                      background: #215CCC;
                      border-radius: 25px;
                      padding-top: 8px;
                      padding-bottom: 8px;
                      text-wrap: nowrap;
                      @media (max-width: 600px) {
                        font-size: 10px;
                        white-space: pre;
                      }
                   "
                >{`${esBoletin ? t('boletin') : t('avance')} ${data.numact}`}</span>
              </div>
            </HeaderHistorico>
          )}
        </Header>
        {children}
      </ResultadosContent>
      <FooterLayout />

    </Layout>
  );
};

const ContenedorLogos = styled.div`
  display: flex;
  align-items: center;
  height: 80px;
  @media (max-width: 1400px) {
    height: 70px;
  }
  @media (max-width: ${responsive.maxWidth.desktop}px) {
    height: 50px;
  }
`;

const HeaderHistorico = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0rem 2rem 2rem 2rem;
  @media (max-width: ${responsive.maxWidth.tablet}px) {
    padding: 0rem;
  }
`;

const Layout = styled(({ primerColor, segundoColor, ...rest }) => (
  <div {...rest} />
))`
  background: linear-gradient(
    to bottom,
    ${({ primerColor }) => primerColor},
    ${({ primerColor }) => primerColor} 179px,
    #fff 179px,
    #fff 100%
  );

  width: fit-content;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: 1fr;
  min-height: 100vh;
`;

const ResultadosContent = styled.div`
  width: 100%;
  height:100%;
  padding: 1rem;
  box-sizing: border-box;
  @media (max-width: ${responsive.maxWidth.tablet}px) {
    padding: 0rem;
  }
 `

const HistoricContainer = styled.div`
  font-size: 14px;
  font-weight: bold;
  @media (max-width: ${responsive.maxWidth.mobile}px) {
    font-size: 10px;
  };
`;

export default LayoutResultados;
